import styled from "styled-components";
import { colors } from "../../../theme/theme";

export const DropzoneContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${colors.mainColors.capri};
  border-style: dashed;
  background-color: ${colors.greyscale.white};
  color: ${colors.mainColors.capri};
  outline: none;
  transition: border .24s ease-in-out;
`;
